/* eslint-disable */
import React, { FunctionComponent, ElementType } from "react";
import { Redirect, Route } from "react-router-dom";

import storage from "../../core/services/storage";
import { CookieBanner } from "../CookieBanner";

interface Props {
  component: ElementType;
  path: string;
  exact?: boolean;
}

const PrivateRoute: FunctionComponent<Props> = ({
  component: Component,
  ...rest
}) => {
  const token = storage.get("token");
  if (!Component) return;

  return (
    <Route
      {...rest}
      render={(props): JSX.Element =>
        token ? (
          <>
            <CookieBanner />
            <Component {...props} />
          </>
        ) : (
          <Redirect to={{ pathname: "/login" }} />
        )
      }
    />
  );
};

export default PrivateRoute;
